import { createFileRoute } from '@tanstack/react-router';
import { ProfileMessagesPage } from './-components/ProfileMessagesPage';

export const Route = createFileRoute('/profile/messages/')({
  component: ProfileMessagesPage,
});
